import type { SelectionCandidateState } from 'api/bcks/useAPIBCKSInvitation'

export const LABEL_NOT_AVAILABLE = 'Belum ada data'

export const SELECTION_STATES_FINAL_PAGE: SelectionCandidateState[] = [
  'documentVerification',
  'documentVerificationFailed',
  'pairing',
  'rejectOffer',
  'reject',
  'failed',
  'finished',
]

export const SELECTION_STATES_ANNOUNCEMENT: SelectionCandidateState[] = [
  'finished',
]
